module.exports = __webpack_public_path__ + "img/img-cartilha-ciclista.0fb16f7d.svg";